import { Link } from "react-router-dom";
import { Button } from "@/components/primitives";
import { Plus, BookOpen } from "lucide-react";

export const PageHeader = () => {
	return (
		<div className="mb-8">
			<div className="flex flex-col space-y-4 sm:flex-row sm:items-center sm:justify-between sm:space-y-0">
				<div className="flex items-center gap-3">
					<div className="p-2 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600">
						<BookOpen className="h-5 w-5 text-white" />
					</div>
					<div>
						<h1 className="text-1xl sm:text-2xl font-semibold text-foreground">
							Your Reflections
						</h1>
						<p className="text-sm sm:text-base text-muted-foreground mt-1">
							Manage and review all your reflections
						</p>
					</div>
				</div>
				<div className="flex items-center gap-2">
					<Link to="/reflection/new" className="w-full sm:w-auto">
						<Button className="w-full sm:w-auto bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white shadow-md hover:shadow-lg transition-all">
							<Plus className="h-4 w-4 mr-2" />
							New Reflection
						</Button>
					</Link>
				</div>
			</div>
		</div>
	);
};
